import * as React from "react";
import { PhotoViewerContext } from "src/share/context/PhotoViewerProvider";

const usePhotoViewer = () => {
  const [state, setState] = React.useContext(PhotoViewerContext);
  
  const handleZoomInImage = ({ source, boundingBoxes }) => {
    const newState = { ...state, source, boundingBoxes, isZoomed: true }
    setState({ ...newState });
  }

  const handleZoomOutImage = () => {
    const newState = { ...state, isZoomed: false };
    setState({ ...newState });
  }

  return {
    handleZoomInImage,
    handleZoomOutImage,
    image: { ...state }
  }
}

export default usePhotoViewer;